import { Component, Input } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the GdxChipPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-gdx-chip',
  templateUrl: 'gdx-chip.html',
})
export class GdxChipPage {
  @Input()  label : any; 
  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad GdxChipPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/gdx-chip/gdx-chip.ts